/**
 * HelpReadmePage — renders the curated public README.md for QUOD-Finder
 * inside the app shell. Falls back to a calm message if the file is not
 * available at runtime. Renders Markdown safely (no HTML pass-through).
 */
import React, { useEffect, useState } from 'react';
import AppHeader from '../layout/AppHeader';
import MarkdownView from './MarkdownView';

const README_URL = '/docs/README.md';

export default function HelpReadmePage() {
  const [state, setState] = useState({ loading: true, text: null, error: null });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await fetch(README_URL, { credentials: 'omit' });
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        const text = await r.text();
        if (!cancelled) setState({ loading: false, text, error: null });
      } catch (e) {
        if (!cancelled) setState({ loading: false, text: null, error: e.message || 'Unavailable' });
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <>
      <AppHeader active="help" />
      <div className="page-shell" data-testid="help-readme-page">
        <div className="qf-glass-panel" style={{ padding: 24, marginTop: 12 }}>
          <h2 style={{ marginTop: 0, fontSize: 22, fontWeight: 700 }}>README</h2>
          <p style={{ fontSize: 12, color: 'var(--text-secondary)', marginTop: 4 }}>
            High-level overview of QUOD-Finder, written for in-app readers.
          </p>
          <hr style={{ border: 0, borderTop: '1px solid var(--border)', margin: '14px 0' }} />
          {state.loading && (
            <div style={{ fontSize: 13 }} data-testid="help-readme-loading">Loading README…</div>
          )}
          {!state.loading && state.text && (
            <MarkdownView source={state.text} testid="help-readme-md" />
          )}
          {!state.loading && !state.text && (
            <div className="qf-md-quote" data-testid="help-readme-fallback">
              README content is not available in this build.
            </div>
          )}
        </div>
      </div>
    </>
  );
}
